import { createApp } from 'vue';
import App from './App';

import Antd from 'ant-design-vue';
import router from './router/index'
import store from './store'
import 'ant-design-vue/dist/antd.less';
import './assets/css/index.less'
import i18n from './locales/setupI18n.js';
import {getPerms} from "@/store/cache";
import VueLazyload from 'vue-lazyload'
import logo from './assets/logo.png'




const app = createApp(App);
// 屏蔽警告信息
app.config.warnHandler = () => null;

// 创建一个权限指令
app.directive('has-permission', (el, binding) => {
    // value 获取用户使用自定义指令绑定的内容
    const {value} = binding
    // 获取用户所有的权限按钮
    const permissionBtn = getPerms();
    // 判断用户使用自定义指令，是否使用正确了
    if (value && value instanceof Array && value.length > 0) {
        const permissionFunc = value
        //判断传递进来的按钮权限，用户是否拥有
        //Array.some(), 数组中有一个结果是true返回true，剩下的元素不会再检测
        const hasPermission = permissionBtn.some((role) => {
            return permissionFunc.includes(role)
        })
        // 当用户没有这个按钮权限时，设置隐藏这个按钮
        if (!hasPermission) {
            el.style.display = 'none'
        }
    } else {
        throw new Error('need roles! Like v-permission="[\'admin\',\'editor\']"')
    }
});
// Object.keys(directives).forEach(key => {  //Object.keys() 返回一个数组，值是所有可遍历属性的key名
//     app.directive(key, (directives[key] )[key])  //key是自定义指令名字；后面应该是自定义指令的值，值类型是string
// })
app.use(VueLazyload, {
    // 设置懒加载时的占位图
    loading: logo,
    // 设置图片加载失败时的占位图
    error: logo
})
app.use(Antd).use(store).use(router).use(i18n).mount('#app');
